import {makeStyles} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {splitPath} from '../../../../_helpers';

const useStyles = makeStyles(theme => ({
  group_item: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  group_item_btn: {
    display: 'flex',
    alignItems: 'flex-end',
    fontStyle: 'normal',
    lineHeight: '120%',
    cursor: 'pointer',
    transition: '.3s all ease',
    fontWeight: 600,
    fontSize: 13,
    gap: 5,

    '& svg path': {
      transition: '.3s all ease',
    },

    '&:hover': {
      color: '#FFBE00',

      '& svg path': {
        fill: '#FFBE00',
        stroke: '#FFBE00',
      },
    },

    '&.active': {
      color: '#FFBE00',

      '& svg path': {
        fill: '#FFBE00',
        stroke: '#FFBE00',
      },
    },
  },
  toggle_btn: {
    background: '#4F4F4F',
    position: 'relative',
    borderRadius: 20,
    width: 32,
    height: 16,
  },
  toggle: {
    background: ' #fff',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    transition: '.3s ease all',
    cursor: 'pointer',
    top: '50%',
    borderRadius: 36,
    width: 16,
    height: 16,

    '&.cargo': {
      transform: 'translateX(-100%) translateY(-50%)',
      background: ' #FFBE00',
      boxShadow: '0px 5px 8px rgba(255, 190, 0, 0.3)',
    },
    '&.passanger': {
      transform: 'translateX(0) translateY(-50%)',
      background: ' #FFBE00',
      boxShadow: '0px 5px 8px rgba(255, 190, 0, 0.3)',
    },
  },
}));

export const Toggle = ({authentication, onFilter, data, toggleCheckbox}) => {
  const item1 = data[0];
  const item2 = data[1];

  const handleToggle = e => {
    if (item1.url === splitPath(window.location.href)[0]) {
      toggleCheckbox(e, parseInt(item2.id), item2.url);
    } else {
      toggleCheckbox(e, parseInt(item1.id), item1.url);
    }
  };

  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <>
      <div className={classes.group_item}>
        <div
          className={clsx(
            classes.group_item_btn,
            splitPath(window.location.href)[0] === item1.url_repr
              ? 'active'
              : '',
          )}
          onClick={e => toggleCheckbox(e, parseInt(item1.id), item1.url)}>
          <svg
            className="svg-stroke"
            width="27"
            height="18"
            viewBox="0 0 27 18"
            fill={onFilter ? '#414D5F' : 'none'}
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.29992 1.5318C1.57708 1.17794 2.02933 0.986464 2.47522 1.00075C6.76014 1.00075 11.0451 1.0018 15.33 1.00075C15.6146 0.999687 15.9108 1.00656 16.1726 1.13139C16.6529 1.35249 16.9628 1.87032 16.9723 2.39397C16.9872 3.06995 16.9708 3.74593 16.9745 4.42191C18.3328 4.41662 19.6916 4.4235 21.0499 4.42244C21.5672 4.41662 22.0872 4.63613 22.4178 5.03865C23.4883 6.31498 24.5562 7.59289 25.6258 8.87028C25.7998 9.08027 25.9394 9.32305 26.0077 9.5891C26.0791 9.8467 26.0732 10.1165 26.0727 10.3815C26.0743 11.3325 26.0664 12.284 26.0796 13.2351C26.0838 13.5625 26.0404 13.9026 25.8654 14.1861C25.6348 14.5754 25.2042 14.8499 24.7477 14.8616C24.3775 14.8732 24.0072 14.8621 23.637 14.8674C23.4756 15.6058 23.0065 16.2786 22.349 16.6573C21.618 17.0868 20.6807 17.1037 19.9143 16.7578C19.1447 16.4172 18.5634 15.693 18.3999 14.8668C15.2723 14.8584 12.1453 14.8594 9.01765 14.8579C8.84892 15.6026 8.38134 16.2844 7.71329 16.6642C6.91777 17.1233 5.88581 17.1027 5.08923 16.6568C4.4106 16.2892 3.9261 15.61 3.76847 14.8573C3.35537 14.86 2.94227 14.8605 2.52917 14.8584C2.20123 14.8552 1.85531 14.8039 1.58502 14.604C1.19837 14.3353 0.987848 13.8592 1.00054 13.3943C1.0016 9.74461 0.998956 6.09494 1.0016 2.44527C0.995253 2.11839 1.0894 1.78569 1.29992 1.5318ZM2.07058 2.30193C2.04572 2.45427 2.06106 2.60977 2.05895 2.76316C2.05789 6.27108 2.06 9.77899 2.05683 13.2869C2.05895 13.3848 2.05313 13.4842 2.07323 13.5805C2.11977 13.727 2.27634 13.8174 2.42656 13.8053C2.87668 13.8026 3.32681 13.809 3.77694 13.8021C3.94778 12.9415 4.56188 12.1756 5.38332 11.8561C6.0117 11.5996 6.74057 11.5769 7.37054 11.8408C8.19462 12.1693 8.84098 12.923 9.01395 13.7963C11.3095 13.8164 13.6057 13.7984 15.9018 13.8053C15.9229 12.5564 15.9102 11.3082 15.9134 10.0593C15.9145 7.52096 15.9124 4.98312 15.9145 2.44474C15.933 2.27919 15.8214 2.09512 15.6495 2.07131C15.4395 2.04963 15.2279 2.06814 15.0174 2.06179C10.8208 2.06338 6.62421 2.06179 2.42762 2.06232C2.27422 2.05122 2.10338 2.14219 2.07058 2.30193ZM16.9829 5.47926C16.9692 8.25565 16.9808 11.032 16.9771 13.8084C17.4484 13.8084 17.9202 13.8069 18.3915 13.8095C18.5729 12.997 19.1119 12.255 19.8815 11.9122C20.5554 11.5964 21.3641 11.5594 22.0486 11.8646C22.8562 12.2042 23.4693 12.9537 23.6481 13.8106C23.9987 13.8016 24.35 13.8164 24.7001 13.8053C24.8842 13.8069 25.0291 13.627 25.009 13.4482C25.009 12.302 25.0085 11.1558 25.009 10.0096C25.018 9.85357 24.9498 9.70759 24.8546 9.58805C23.7851 8.31066 22.715 7.03381 21.6444 5.75748C21.5149 5.59139 21.3186 5.46921 21.1023 5.47979C19.7292 5.47873 18.356 5.48032 16.9829 5.47926ZM6.15768 12.7421C5.42405 12.84 4.81154 13.4995 4.79144 14.2432C4.69729 15.0271 5.32355 15.7846 6.08839 15.9157C6.72735 16.0453 7.42608 15.7454 7.76354 15.1863C8.18087 14.5595 8.03118 13.6492 7.48267 13.1489C7.13357 12.8193 6.63003 12.6733 6.15768 12.7421ZM20.6326 12.776C19.9825 12.9262 19.4726 13.5196 19.4139 14.1829C19.3002 14.9933 19.936 15.7978 20.7363 15.92C21.3879 16.0432 22.094 15.72 22.4178 15.1398C22.8071 14.5109 22.6388 13.6291 22.0956 13.143C21.7116 12.7834 21.1398 12.6501 20.6326 12.776Z"
              fill={onFilter ? '#414D5F' : 'white'}
              stroke={onFilter ? '#414D5F' : 'white'}
              strokeWidth="0.6"
            />
          </svg>
          <div className="toggle-text">
            {!authentication.loggedIn && t('common:cargo')}
          </div>
        </div>
        <div
          style={{backgroundColor: onFilter ? '#EBF0F8' : '#4F4F4F'}}
          className={classes.toggle_btn}
          onClick={e => handleToggle(e)}>
          <span
            className={clsx(
              classes.toggle,
              splitPath(window.location.href)[0] === item1.url_repr
                ? 'cargo'
                : 'passanger',
            )}></span>
        </div>
        <div
          className={clsx(
            classes.group_item_btn,
            'passanger',
            splitPath(window.location.href)[0] === item2.url_repr
              ? 'active'
              : '',
          )}
          onClick={e => toggleCheckbox(e, parseInt(item2.id), item2.url)}>
          <svg
            className="svg-stroke"
            width="25"
            height="15"
            viewBox="0 0 25 15"
            fill={onFilter ? '#414D5F' : 'none'}
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.49721 1.6797C5.2409 1.25034 6.08717 0.990669 6.94389 1.00143C8.98595 0.99996 11.028 1.00094 13.0701 1.00045C13.3735 1.00192 13.6799 0.988712 13.9805 1.04202C14.5513 1.14373 15.0913 1.42492 15.5077 1.83961C16.2918 2.64503 17.0744 3.45192 17.8575 4.25832C18.075 4.47887 18.2797 4.72876 18.5661 4.85835C18.8054 4.98159 19.0766 5.00653 19.3402 5.00653C19.8944 5.00555 20.4486 5.00653 21.0028 5.00555C21.3219 5.00457 21.6449 5.0256 21.9516 5.1234C22.9798 5.41975 23.8023 6.34645 23.9946 7.42866C24.1485 8.4248 24.2682 9.42681 24.4206 10.4229V10.4904C24.4016 10.7594 24.3484 11.0313 24.2088 11.2631C23.9633 11.6998 23.4865 11.9922 22.995 11.9922C22.4802 11.9991 21.9654 11.9898 21.4506 11.9966C21.2882 12.8152 20.7117 13.5341 19.9504 13.8305C19.3069 14.0887 18.5547 14.0486 17.9449 13.7131C17.3086 13.3732 16.8341 12.7272 16.6997 12.001C14.0702 11.9849 11.4407 11.9996 8.81119 11.9937C8.65115 12.7585 8.14681 13.4422 7.45203 13.7688C6.70501 14.1322 5.77801 14.0637 5.09226 13.5879C4.55135 13.2295 4.18235 12.6358 4.04416 11.9932C3.05637 11.9952 2.06858 11.9947 1.08032 11.9937C1.08696 11.6299 1.06797 11.265 1.09456 10.9017C1.10833 9.77695 1.07652 8.65219 1.09979 7.52744C1.15962 6.52201 1.408 5.52636 1.84253 4.62264C2.4257 3.40644 3.34368 2.34575 4.49721 1.6797ZM2.72869 5.0031C4.12537 5.00995 5.52204 5.00359 6.91919 5.00653C6.93249 4.00158 6.92157 2.99566 6.92442 1.99072C5.12788 2.09195 3.45196 3.31108 2.72869 5.0031ZM7.88134 1.98436C7.87991 2.99126 7.87849 3.99816 7.88181 5.00506C10.9943 5.00506 14.1068 5.00946 17.2188 5.0031C16.4661 4.20111 15.6882 3.42405 14.9265 2.63085C14.6254 2.30516 14.2241 2.07337 13.79 2.00784C13.488 1.97067 13.1831 1.98632 12.8796 1.9829C11.2132 1.98387 9.54728 1.98094 7.88134 1.98436ZM2.34734 5.98702C2.18208 6.4824 2.1004 7.00419 2.05766 7.52451C2.04009 8.68643 2.05291 9.84835 2.04958 11.0103C2.71587 11.0117 3.38167 11.0098 4.04748 11.0108C4.2118 10.2044 4.7717 9.49576 5.51872 9.19208C6.21254 8.9016 7.03649 8.9637 7.67666 9.36666C8.25603 9.72022 8.66635 10.3335 8.80739 11.0093C11.4364 11.0127 14.0659 11.0093 16.6955 11.0108C16.8569 10.1662 17.4705 9.43463 18.2612 9.15393C18.8643 8.93436 19.5529 8.96908 20.1285 9.25956C20.8005 9.58867 21.301 10.2562 21.4449 11.0073C21.945 11.0132 22.4446 11.0117 22.9446 11.0083C23.2301 11.0313 23.486 10.7491 23.4537 10.4591C23.3493 9.69332 23.2415 8.92751 23.1356 8.16121C23.09 7.8502 23.0667 7.52989 22.9446 7.23745C22.7267 6.68534 22.2584 6.24767 21.7037 6.077C21.4145 5.98164 21.1068 5.98555 20.8067 5.988C14.6539 5.98702 8.50061 5.98897 2.34734 5.98702ZM6.06295 10.042C5.56431 10.1711 5.14877 10.5868 5.01532 11.0988C4.85101 11.6631 5.05759 12.3101 5.50305 12.6754C5.96275 13.0749 6.66987 13.1214 7.18086 12.7996C7.76926 12.449 8.05183 11.6504 7.80773 10.9941C7.5736 10.2777 6.77103 9.83905 6.06295 10.042ZM18.6976 10.0449C18.0285 10.2136 17.5408 10.9178 17.6106 11.625C17.6462 12.1878 18.0214 12.7057 18.5314 12.9082C19.0813 13.136 19.759 12.981 20.1541 12.5223C20.4937 12.1472 20.6134 11.5912 20.4832 11.0998C20.3797 10.7071 20.1119 10.3662 19.7643 10.1745C19.4413 9.99407 19.0524 9.94908 18.6976 10.0449Z"
              fill={onFilter ? '#414D5F' : 'white'}
              stroke={onFilter ? '#414D5F' : 'white'}
              strokeWidth="0.6"
            />
          </svg>
          <div className="toggle-text">
            {!authentication.loggedIn && t('common:passanger')}
          </div>
        </div>
      </div>
    </>
  );
};
